export class Color {
  code: string;
  hex: string;

  // tslint:disable-next-line:no-any
  constructor(data: any) {
    this.code = data.code;
    this.hex = data.hex;
  }
}
